import api from "@/services/api";

export const contactsAdmin = {
    namespaced: true,
    state: () => ({
        messages: [],
        loading: false,
        error: null
    }),
    getters: {
        allMessages: (state) => state.messages,
        isLoading: (state) => state.loading,
        hasError: (state) => state.error
    },
    mutations: {
        SET_MESSAGES(state, messages) { state.messages = messages; },
        SET_LOADING(state, val) { state.loading = val; },
        SET_ERROR(state, err) { state.error = err; },
        UPDATE_MESSAGE(state, updated) {
            const index = state.messages.findIndex(m => m.id === updated.id);
            if (index !== -1) state.messages[index] = updated;
        },
        DELETE_MESSAGE(state, id) {
            state.messages = state.messages.filter(m => m.id !== id);
        },
    },
    actions: {
        async fetchMessages({ commit, rootState }) {
            commit("SET_LOADING", true);
            try {
                const token = rootState.admin.token;
                const response = await api.get("/Contact/getAll", {
                    headers: { Authorization: `Bearer ${token}` }
                });
                commit("SET_MESSAGES", response.data);
            } catch (err) { commit("SET_ERROR", err); }
            finally { commit("SET_LOADING", false); }
        },
        async updateMessageReadStatus({ commit, rootState }, { id, isRead }) {
            try {
                const token = rootState.admin.token;
                const response = await api.patch(`/Contact/mark-read/${id}`, isRead, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                commit("UPDATE_MESSAGE", response.data.contactDto);
            } catch (err) {
                console.error("Mesaj okundu durumunu güncelleme hatası:", err);
            }
        },
        async deleteMessage({ commit, rootState }, id) {
            try {
                const token = rootState.admin.token;
                await api.delete(`/Contact/delete/${id}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                commit("DELETE_MESSAGE", id);
            } catch (err) {
                console.error("Mesaj silme hatası:", err);
            }
        },
    }
};
